<template>
    <div class="sidebar">
      <ul>
        <li v-for="item in menu" :key="item.path">
          <router-link :to="item.path" active-class="active">
            <i :class="item.icon"></i>
            <span class="menu-text">{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "Sidebar",
    data() {
      return {
        menu: [
          { name: "个人信息", path: "/person/info", icon: "el-icon-user" },
          // { name: "我的测评", path: "/person/review", icon: "el-icon-document" },
          { name: "我的购书", path: "/person/order", icon: "el-icon-reading" },
          // { name: "意见与异议", path: "/person/feedback", icon: "el-icon-message" },
          { name: "收货地址", path: "/person/address", icon: "el-icon-location" },
          { name: "发票抬头", path: "/person/invoice", icon: "el-icon-tickets" },
          // { name: "智能客服", path: "/person/service", icon: "el-icon-service" },
          // { name: "关于我们", path: "/person/about", icon: "el-icon-info" }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .sidebar {
    min-width: 200px;
    max-width: 200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.08);
    border: 1px solid #f0f0f0;
    /* padding: 24px 0; */
    min-height: 100vh;
  }
  .sidebar ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .sidebar li {
    margin-bottom: 8px;
  }
  .sidebar .router-link-exact-active,
  .sidebar .active {
    background: #3172D7;
    color: #fff;
    font-weight: bold;
  }
  .sidebar a {
    display: flex;
    align-items: center;
    padding: 10px 24px;
    color: #333;
    text-decoration: none;
    transition: background 0.2s, color 0.2s;
  }
  .sidebar a:hover {
    background: #f5f7fa;
    color: #409EFF;
  }
  .sidebar i {
    font-size: 20px;
    margin-right: 12px;
  }
  .menu-text {
    flex: 1;
  }
  </style>